export default __webpack_public_path__ + "static/media/way-1.700c687f.png";